module.exports = __webpack_public_path__ + "static/media/kibecatupiry.ccd73689.webp";